import { RouterContext } from "@/router";
import { ParsedLocation, redirect } from "@tanstack/react-router";

import {
  TenantStatus,
  UserTenantStatus,
} from "@gx/ts-contracts/services/database/models/public_pb";

export const requiresWorkOSAuth = (ctx: RouterContext, location: ParsedLocation) => {
  if (!ctx.workosAuth.user) {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: "/login",
      search: { redirect: location.href },
    });
  }
};

export const requiresCurrentUser = (ctx: RouterContext, location: ParsedLocation) => {
  if (!ctx.currentUser) {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: "/login",
      search: { redirect: location.href },
    });
  }
};

export const requiresOnboarding = (ctx: RouterContext) => {
  if (
    ctx.currentUser?.user?.currentTenant?.status === UserTenantStatus.PENDING ||
    ctx.currentUser?.user?.currentTenant?.tenant?.status === TenantStatus.PENDING
  ) {
    throw redirect({ to: "/onboarding", search: {} }); // eslint-disable-line @typescript-eslint/only-throw-error
  }
};

export const requiresGuardianOfTheGalaxy = (ctx: RouterContext) => {
  if (!ctx.currentUser?.user?.isGuardianOfTheGalaxy) {
    throw redirect({ to: "/settings", search: {} }); // eslint-disable-line @typescript-eslint/only-throw-error
  }
};

export const redirectIfOnboarded = (ctx: RouterContext) => {
  if (
    ctx.currentUser?.user?.currentTenant?.status === UserTenantStatus.ACTIVE &&
    ctx.currentUser?.user?.currentTenant?.tenant?.status === TenantStatus.ACTIVE
  ) {
    throw redirect({ to: "/projects", search: {} }); // eslint-disable-line @typescript-eslint/only-throw-error
  }
};
